
export const currencyColumnsList = [
    { key: "code", label: "Currency Code", visible: true },
    { key: "symbol", label: "Symbol", visible: true },
    { key: "rate", label: "Price (INR)", visible: true },
    { key: "flag", label: "Flag", visible: true },
     { key: "updatedAt", label: "Updated At", visible: true },
    { key: "createdAt", label: "Created At", visible: false },
    { key: "isActive", label: "Is Active", visible: true },
    { key: "actions", label: "Actions", visible: true },
];
export const productColumnsList = [
    { key: "image", label: "Image", visible: true },
    { key: "name", label: "Name", visible: true },
    { key: "sku", label: "SKU", visible: true },
    { key: "quantity", label: "Quantity", visible: true },
    { key: "price", label: "Price", visible: true },
    { key: "discount", label: "Discount", visible: false },
    { key: "isCatalogue", label: "IsCatalogue", visible: false },
    { key: "status", label: "Is Active", visible: true },                                                                                                                                                                           
    { key: "updatedAt", label: "Updated At", visible: true },
    { key: "createdAt", label: "Created At", visible: false },
    { key: "action", label: "Action", visible: true },                                                                                          
];

export const searchProductColumnsList = [
    { key: "image", label: "Image", visible: true },
    { key: "name", label: "Name", visible: true },
    { key: "sku", label: "SKU", visible: true },
    { key: "quantity", label: "Quantity", visible: true },
    { key: "price", label: "Price", visible: true },
    { key: "discount", label: "Discount", visible: false },
    { key: "isCatalogue", label: "IsCatalogue", visible: false },
    { key: "status", label: "Is Active", visible: true },   
    { key: "outofStock", label: "Out of Stock", visible: true },                                                                                                                                                              
    { key: "updatedAt", label: "Updated At", visible: true },  
    { key: "action", label: "Action", visible: true },                                                                                    
];
export const catalogueColumnsList = [
    { key: "image", label: "Image", visible: true },
    { key: "name", label: "Name", visible: true },  
    { key: "sku", label: "SKU", visible: true },
    { key: "price", label: "Price", visible: true },
    { key: "discount", label: "Discount", visible: false },
    { key: "avg price", label: "Avg Price", visible: false },
    { key: "offer price", label: "Offer Price", visible: false },
    { key: "product", label: "Product", visible: true },
    { key: "status", label: "Is Active", visible: true },
    { key: "outofStock", label: "Out of Stock", visible: true },
    { key: "createdAt", label: "Created At", visible: false },
    { key: "updatedAt", label: "Updated At", visible: true },
    { key: "action", label: "Action", visible: true },
];

export const searchCatalogueColumnsList = [
    { key: "image", label: "Image", visible: true },
    { key: "name", label: "Name", visible: true },  
    { key: "sku", label: "SKU", visible: true },
    { key: "price", label: "Price", visible: true },
    { key: "discount", label: "Discount", visible: false },
    { key: "avg price", label: "Avg Price", visible: false },
    { key: "offer price", label: "Offer Price", visible: false },
    { key: "product", label: "Product", visible: true },
    { key: "status", label: "Is Active", visible: true },
    { key: "outofStock", label: "Out of Stock", visible: true },
    { key: "updatedAt", label: "Updated At", visible: true },
    { key: "action", label: "Action", visible: true },
];